interface PostMessage {
    type?: string;
    event: string;
    payload?: object;
}

/**
 *
 * @param {Object} message
 * @param {string} targetOrigin
 * @param {boolean} serialize
 */
export function sendPostMessage(message: PostMessage, targetOrigin: string, serialize = true) {
    window.top?.postMessage(serialize ? JSON.stringify(message) : message, targetOrigin);
}

/**
 * @returns {boolean}
 */
export function isInsideIframe() {
    return window.top !== window.self;
}
